<template>
    <div class="dialog-body">
        <h1>Forgot password</h1>
        <span class="pt-2">Enter your registered email address here.</span>
        <div class="info-container">
            <div class="form-sec">
                <form method="post" :action="url" @submit.prevent="submitForm" novalidate="novalidate">
                    <input type="hidden" name="_token" :value="$csrf">
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" class="form-control col-md-10" id="email" placeholder="Enter email"
                            name="email" v-model="email" maxlength="191" />
                    </div>

                    <button type="submit" class="btn btn-blue" :disabled="isSubmitting">
                        Reset password
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.dialog-body {
    margin: 50px 10px;
}
.btn-blue {
    padding: auto;
}
</style>
<script>
    export default {
            
        props: [
            "dataUserType"
          ],
        // Note: data-email and data-mobile becomes camel case in props
        data() {
            return {
                url: this.$routes['member_forgot_password'],
                email: '',
                isSubmitting: false,
                errorMessage: '',
                userType: this.dataUserType
            }
            
        },

        methods: {
            async submitForm() {
                this.isSubmitting = true;
                this.errorMessage = '';

                var result = await this.$asyncPost(this.url, {
                    'email': this.email,
                    'userType': this.userType,
                });

                this.isSubmitting = false;

                if (result.status == 'success') {
                    Swal.fire({
                      type: 'success',
                      title: 'Success',
                      text: result.message,
                    }).then(() => {
                          this.$redirect(this.$routes['home']);
//                        switch(this.dataUserType){
//                            case 'user':
//                                this.$redirect(this.$routes['home']);
//                                break;
//                            case 'merchant':
//                                this.$redirect(this.$routes['partner_login']);
//                                  break;
//                             case 'admin':
//                                this.$redirect(this.$routes['admin_login']);   
//                              break;
//                        }
                    });
                } else {
                    this.errorMessage = result.message;
                }

            }
        },

        
    }
</script>
